import { render, staticRenderFns } from "./dataLoadingDialog.vue?vue&type=template&id=2dc710c4&scoped=true"
import script from "./dataLoadingDialog.vue?vue&type=script&lang=js"
export * from "./dataLoadingDialog.vue?vue&type=script&lang=js"
import style0 from "./dataLoadingDialog.vue?vue&type=style&index=0&id=2dc710c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc710c4",
  null
  
)

export default component.exports